import toArray from 'shadow-fns/src/toArray'
import isObject from './isObject'

const reduceObj = (cb, obj) => (prev, key, index) => {
  cb(prev, key, obj[key], index)
  return prev
}

const reduceArr = (cb) => (prev, val, index) => {
  cb(prev, val, index)
  return prev
}

const reduce = (obj, callback, res) => {
  const isOb = isObject(obj)
  const iter = isOb ? Object.keys(obj) : toArray(obj)
  const cbFn = isOb ? reduceObj(callback, obj) : reduceArr(callback)
  const init = res ? res : isOb ? {} : []

  return iter.reduce(cbFn, init)
}

export default reduce
